import { getPercentage } from './getPercentage';

export const getTableRows = (data) => {
	return data.map((row) => (
		<tr>
			<td>{row.no}</td>
			<td>{row.mailConfigName}</td>
			<td>{row.requested}</td>
			<td>
				{row.toSend !== null &&
					`${row.toSend} ${getPercentage(row.toSend / row.requested)}`}
			</td>
			<td>
				{row.sent !== null &&
					`${row.sent} ${getPercentage(row.sent / row.requested)}`}
			</td>
			<td>
				{row.delivered !== null &&
					`${row.delivered} ${getPercentage(row.delivered / row.sent)}`}
			</td>
			<td>
				{row.opened !== null &&
					`${row.opened} ${getPercentage(row.opened / row.sent)}`}
			</td>
			<td>
				{row.clicked !== null &&
					`${row.clicked} ${getPercentage(row.clicked / row.sent)}`}
			</td>
			<td>
				{row.bounced !== null &&
					`${row.bounced} ${getPercentage(row.bounced / row.sent)}`}
			</td>
			<td>
				{row.bought !== null &&
					`${row.bought} ${
						row.delivered ? getPercentage(row.bought / row.delivered) : ''
					}`}
			</td>
			<td>{`${row.boughtValue.toFixed(2)} PLN`}</td>
		</tr>
	));
};
